<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Edit Cancellation Reason</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
                <cancellation-reasons-form
					:reason="tempReason" :reasonTypesOptions="getReasonTypesOptions"
					@canSaveReason="canSaveReason = $event"
				></cancellation-reasons-form>
                <!-- <div class="d-flex justify-content-end">
                    <button class="btn action" @click="deleteChannel(tempReason)">Delete</button>
                </div> -->
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import cancellationReasonsForm from './cancellationReasonsForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempReason: null
            }
        },
        created: function() {
            this.tempReason = JSON.parse(JSON.stringify(this.getSelectedReason))
        },
        computed: {
            ...mapGetters([
                'getSelectedReason',
				'getReasonTypesOptions',
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'setSelectedReason',
                'deleteReason',
                'updateReason',
                'initReasons'
            ]),
            deleteChannel: function(reason) {
                this.deleteReason(reason)
            },
            save: function() {
                this.updateReason(this.tempReason).then(success => {
                    if(success == true){
                        this.closeModal();
                        this.initReasons();
                    }
                })
            },
            close: function() {
                this.setSelectedReason(null)
                this.closeModal();
            },
        },
        components: {
            Modal,
            cancellationReasonsForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// editCancellationReason.vue?6bfcb902